
  var _styles = {
  "coupon-horizontal-wrapper": {
    "display": "flex",
    "flexDirection": "column",
    "width": "9.36rem",
    "position": "relative"
  },
  "coupon-horizontal-with-bg": {
    "position": "relative",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": 0,
    "backgroundColor": "rgba(0,0,0,0)"
  },
  "background-image": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "100%",
    "height": "100%",
    "borderRadius": "0.32rem",
    "zIndex": 0
  },
  "coupon-horizontal-scroll": {
    "display": "flex",
    "flexDirection": "row",
    "width": "100%",
    "paddingRight": "0.16rem",
    "paddingLeft": "0.32rem"
  },
  "scroll-content": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-start"
  },
  "coupon-card-horizontal-item": {
    "display": "flex",
    "flexDirection": "column",
    "flexShrink": 0,
    "width": "3.46667rem",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.21333rem",
    "padding": "0.26667rem",
    "marginRight": "0.21333rem",
    "justifyContent": "space-between"
  },
  "card-header": {
    "display": "flex",
    "flexDirection": "column",
    "marginBottom": "0.21333rem",
    "minHeight": "0.8rem"
  },
  "card-title": {
    "fontSize": "0.37333rem",
    "lineHeight": "0.66667rem",
    "color": "rgb(51,51,51)",
    "fontWeight": "500",
    "fontFamily": "PingFang SC"
  },
  "card-price": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "marginBottom": "0.16rem"
  },
  "card-threshold": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "marginBottom": "0.21333rem"
  },
  "threshold-text": {
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem",
    "color": "rgb(255,45,25)",
    "fontWeight": "400",
    "fontFamily": "PingFang SC"
  },
  "card-button": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "marginBottom": "0.16rem"
  },
  "card-expire": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "expire-text": {
    "fontSize": "0.29333rem",
    "lineHeight": "0.42667rem",
    "color": "rgb(153,153,153)",
    "fontWeight": "400",
    "fontFamily": "PingFang SC"
  },
  "coupon-horizontal-claim-all": {
    "position": "absolute",
    "bottom": 0,
    "left": 0,
    "width": "9.36rem",
    "height": "2.06667rem",
    "display": "flex",
    "zIndex": 1
  },
  "claim-all-bg": {
    "width": "9.36rem",
    "height": "2.06667rem"
  },
  "claim-all-button-wrapper": {
    "position": "absolute",
    "width": "100%",
    "height": "100%",
    "zIndex": 2,
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "marginTop": "0.16rem"
  },
  "claim-all-button": {
    "width": "5.33333rem",
    "height": "1.06667rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "borderRadius": "1.06667rem"
  },
  "claim-all-button-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.37333rem",
    "lineHeight": "1.06667rem",
    "textAlign": "center"
  },
  "coupon-horizontal-title": {
    "paddingTop": "0.21333rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.21333rem",
    "paddingLeft": "0.32rem",
    "height": "1.01333rem"
  },
  "coupon-horizontal-title-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "lineHeight": "0.58667rem",
    "textAlign": "left"
  }
};



  module.exports = _styles;
  